import { useMemo, useRef } from 'react'

export const useScrollToElement = <T extends HTMLElement>() => {
  const ref = useRef<null | T>(null)

  return useMemo(() => {
    return {
      ref,
      scrollToElement: () => ref?.current?.scrollIntoView({ behavior: 'smooth', inline: 'start' }),
    }
  }, [ref])
}
